var map = {
	"./white_paper1.png": "c094",
	"./white_paper10.png": "015e",
	"./white_paper11.png": "da4b",
	"./white_paper12.png": "d812",
	"./white_paper13.png": "0ba3",
	"./white_paper14.png": "1060",
	"./white_paper15.png": "4b4f",
	"./white_paper16.png": "d6cd",
	"./white_paper17.png": "7f3c",
	"./white_paper18.png": "be3b",
	"./white_paper19.png": "611f",
	"./white_paper2.png": "6e8a",
	"./white_paper20.png": "35ef",
	"./white_paper21.png": "5c23",
	"./white_paper22.png": "82a6",
	"./white_paper23.png": "f0a1",
	"./white_paper3.png": "33ed",
	"./white_paper4.png": "b0ab",
	"./white_paper5.png": "24d5",
	"./white_paper6.png": "3d93",
	"./white_paper7.png": "7ceb",
	"./white_paper8.png": "7d58",
	"./white_paper9.png": "f56b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c0b";